const development = {
  KYC_BUCKET_URL: process.env.KYC_BUCKET_URL,
  MEDIA_BUCKET_URL: process.env.MEDIA_BUCKET_URL,
  API_URL: process.env.REACT_APP_AXIOS_BASE_URL_DEV,
  SOCKET_URL: 'http://localhost:1997'
}

// const dev = {
//   KYC_BUCKET_URL: 'https://housieskill-kyc-doc.s3.ap-south-1.amazonaws.com/dev/',
//   MEDIA_BUCKET_URL: 'https://housieskill-media.s3.ap-south-1.amazonaws.com/dev/',
//   API_URL: 'https://node-dev.housieskill.com/api/v1',
//   SOCKET_URL: 'https://socket-dev.housieskill.com'
// }

const prod = {
  KYC_BUCKET_URL: process.env.KYC_BUCKET_URL,
  MEDIA_BUCKET_URL: process.env.MEDIA_BUCKET_URL,  
  API_URL: process.env.REACT_APP_AXIOS_BASE_URL_PROD,  
  SOCKET_URL: 'https://socket.housieskill.com/'
}

let environment
if (process.env.REACT_APP_ENVIRONMENT === 'development') {
  environment = development
} else if(process.env.REACT_APP_ENVIRONMENT === 'prod') {
  environment = prod;
}else {
  environment = 'default'; 
}
  
export default environment